// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cogSmallCog16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog-small-cog': IconCogSmallCog;
    }
}

/**
 * The icon component for the 'cogSmallCog' icon
 */
export class IconCogSmallCog extends Icon {
    public constructor() {
        super(cogSmallCog16X16);
    }
}

registerIcon('icon-cog-small-cog', IconCogSmallCog);
export const iconCogSmallCogTag = 'nimble-icon-cog-small-cog';
